/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


const router = new Router({
    // mode: 'history',
    mode: process.env.VUE_APP_ROUTER_MODE,
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

      {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '',
        component: () => import('./layouts/main/Main.vue'),
        children: [
      // =============================================================================
      // Theme Routes
      // =============================================================================
/*           {
            path: '/',
            name: 'home',
            component: () => import('./views/Home.vue'),
            meta: {
              rule: 'public'
            }
          }, */
          {
            path: '/',
            redirect: '/marcar'   /* redirect when come to this page */
          },
          {
            path: '/calendarOld',
            name: 'Início',
            /* component: () => import('./components/Calendar.vue') */
            component: () => import('./views/apps/calendar/FullCalendar.vue')
          },
          {
            path: '/marcar',
            name: 'marcar',
            /* component: () => import('./components/Calendar.vue') */    /* need to activate vuetify */
            component: () => import('./components/externos/Scheduler.vue'),
            meta: {               
              rule: 'public',           /* acl permissions  */
              auth: true               /* allow authorization or not on vue router, manually putted */
            }
          },
          {
            path: '/marcarOutras',
            name: 'marcarOutras',
            component: () => import('./components/externos/marcarOutras.vue'),
            meta: {               
              rule: 'public',           /* acl permissions  */
              auth: true               /* allow authorization or not on vue router, manually putted */
            }
          },
          {
            path: '/debito',
            name: 'debito',
            component: () => import('./components/externos/debito.vue'),
            meta: {               
              rule: 'public',           /* acl permissions  */
              auth: true               /* allow authorization or not on vue router, manually putted */
            }
          },
          {
            path: '/relatorio-faturacao',
            name: 'faturacao',
            component: () => import('./components/externos/relatorios/faturacao.vue'),
            meta: {
              rule: 'public',
              auth: true,
            }
          },
          {
            path: '/cliente',
            name: 'cliente',
            component: () => import('./components/externos/Client.vue'),
            meta: {               
              rule: 'public',           /* acl permissions  */
              auth: true               /* allow authorization or not on vue router, manually putted */
            }
          },
          {
            path: '/horarios',
            name: 'horarios',
            component: () => import('./components/externos/horario.vue'),
            meta: {
              rule: 'manager',
              auth: true,
            }
          },
          {
            path: '/clube',
            name: 'clube',
            component: () => import('./components/externos/clube.vue'),
            meta: {
              rule: 'public',
              auth: true,
            }
          },
          {
            path: '/spa',
            name: 'spa',
            component: () => import('./components/externos/spa.vue'),
            meta: {
              rule: 'admin',
              auth: true,
            }
          }, 
          {
            path: '/evento',
            name: 'evento',
            component: () => import('./components/externos/evento.vue'),
            meta: {
              rule: 'public',
              auth: true,
            }
          }, 
          {
            path: '/sala',
            name: 'sala',
            component: () => import('./components/externos/sala.vue'),
            meta: {
              rule: 'manager',
              auth: true,
            }
          },        
          {
            path: '/terapeuta',
            name: 'terapeuta',
            component: () => import('./components/externos/terapeuta.vue'),
            meta: {
              rule: 'manager',
              auth: true,
            }
          },
          {
            path: '/exploracao',
            name: 'exploracao',
            component: () => import('./components/externos/exploracao.vue'),
            meta: {
              rule: 'manager',
              auth: true,
            }
          },
          {
            path: '/teste',
            name: 'teste',
            component: () => import('./components/externos/teste.vue'),
            meta: {
              rule: 'admin',
              auth: true
            }
          },                      
          {            
            path: '/error',
            name: 'error',
            component: () => import('./views/pages/NotAuthorized.vue'),
            meta: {
              rule: 'public',
              auth: false
            }
          },
      // =============================================================================
      // Application Routes
      // =============================================================================
          {
            path: '/apps/calendar/vue-fullcalendar',
            name: 'calendarFullCalendar',
            component: () => import('./views/apps/calendar/FullCalendar.vue'),
            meta: {
              rule: 'editor'
            }
          },
          {
            path: '/apps/calendar/vue-simple-calendar',
            name: 'calendarSimpleCalendar',
            component: () => import('./views/apps/calendar/SimpleCalendar.vue'),
            meta: {
              rule: 'editor'
            }
          },

          
        ],
      },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
      {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
      // =============================================================================
      // PAGES
      // =============================================================================
          {
            path: '/login',
            name: 'pageLogin',
            component: () => import('@/views/pages/Login.vue'),
            meta: {
              rule: 'public',
              auth: false,              
            }
          },
          {
            path: '/pages/error-404',
            name: 'pageError404',
            component: () => import('@/views/pages/Error404.vue'),
            meta: {
              rule: 'public'
            }
          },
          {
            path: '/pages/error-500',
            name: 'pageError500',
            component: () => import('@/views/pages/Error500.vue'),
            meta: {
              rule: 'public'
            }
          },
          {
            path: '/pages/not-authorized',
            name: 'pageNotAuthorized',
            component: () => import('@/views/pages/NotAuthorized.vue'),
            meta: {
              rule: 'public'
            }
          },
          {
            path: '/survey',
            name: 'survey',
            component: () => import('./components/externos/survey.vue'),
            meta: {
              rule: 'public',
              auth: false
            }
          },
          {
            path: '/survey2/:data/:lang?',     //send parameters as json on url
            name: 'survey2',
            component: () => import('./components/externos/survey.vue'),
            meta: {
              rule: 'public',
              auth: false
            }
          },
          {
            path: '/survey3/:schedule_id/:survey_id',     //send parameters as json on url
            name: 'survey3',
            component: () => import('./components/externos/survey.vue'),
            meta: {
              rule: 'public',
              auth: false
            }
          },
          {
            path: '/consultationCard/:event_schedule_id/:cod_pessoa/:consultation_card_id?',
            name: 'consultationCard',
            component: () => import('./components/externos/consultationCard.vue'),
            meta: {
              rule: 'public',
              auth: false
            }
          },

        ]
      },
      // Redirect to 404 page, if no match found
      {
        path: '*',
        redirect: '/pages/error-404',
        meta: {
          rule: 'public'
        }
      }
    ],  //routes
});  //router

router.afterEach(() => {        /* global after hook */
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

let userData = null;    //to store data from session

/* executed before each route */
router.beforeEach((to, from, next) => {     /* global guard */
  
  /* check if user is logged in  (token usertoken) and page is autorized to view without authentication */
  if(window.localStorage.getItem('usertoken') === null && to.meta.auth){
    next('/login');   /* redirect to login if no user is logged */
  }else{ 
    //check logged in user type (admin or other bosses and if it's not the same as the previous logged in since the logout only destroy the session )
    if(window.localStorage.getItem('userSession') !== null && userData !== JSON.parse( window.localStorage.getItem('userSession')) ){
      userData = JSON.parse( window.localStorage.getItem('userSession'));   //retrive data from session 
    }

    //check if have permissions to access to the links (1) and permissions from profile (7 is admin and 110 is others bosses)
    if((to.meta.rule == 'public')
      ||
      (to.meta.rule == 'manager' && (userData.istherapistmanager != 0 || ['5','7','110'].indexOf(userData.userType) !== -1))
      ||
      (to.meta.rule == 'admin' && ['5','7','110'].indexOf(userData.userType) !== -1)
      ||
      (userData.isSpaDirector && ['5','7','110'].indexOf(userData.userType) !== -1)
      ){
  
      next();   //redirect to the route since have perissions
    }else{
      next({name: 'marcar'})
    }
    
  }
  

});

export default router
